import { ProjectionDetails } from '@interfaces/open-choice/projection-details.model';
import { RiskDescriptionEnum } from '@interfaces/open-choice/risk-quiz.enum';
import { createAction, props } from '@ngrx/store';

export const acceptDAOffer = createAction('[Open Choice] Accept DA Offer');

export const gotDAOffer = createAction('[Open Choice] Got DA Offer');

export const initializeOnboarding = createAction('[Open Choice] Initialize Onboarding');

export const rejectDAOffer = createAction('[Open Choice] Reject DA Offer');

export const rollbackOnboarding = createAction('[Open Choice] Rollback Onboarding');

export const RetakeRiskQuiz = createAction('[Open Choice] Retake Risk Quiz');

export const enrollInDA = createAction('[Open Choice] Enroll in DA');

export const enrollInDASuccess = createAction('[Open Choice] Enroll Success in DA');

export const UpdateDAAccountsToEnroll = createAction(
  '[Open Choice] Update Multi Account Enrollment Selection',
  props<{ payload: ProjectionDetails }>(),
);

export const UpdateAccountId = createAction(
  '[Open Choice] Update accountID',
  props<{ payload: string }>(),
);

export const UpdateDAComponentFailure = createAction(
  '[Open Choice] Update DA Component Failure State',
  props<{ payload: boolean }>(),
);

export const UpdatePortfolioMatchResult = createAction(
  '[Open Choice] Update Portfolio Match Result',
  props<{ payload: RiskDescriptionEnum | null }>(),
);

export const UpdateDraftID = createAction(
  '[Open Choice] Update Draft ID',
  props<{ payload: string }>(),
);

export const CheckClientEligibility = createAction(
  '[Open Choice] Check Client Digital Advice Eligibility',
);
export const UpdateOnboardingInitialized = createAction(
  '[Open Choice] Update Onboarding Initialized',
  props<{ payload: boolean }>(),
);

export const UpdateEnrollPageHTML = createAction(
  '[Open Choice] Update Enroll Page HTML',
  props<{ payload: string }>(),
);
